import { BaseModel, BaseWithId } from '@app/shared/models/base';
import { BaseWithIdList } from '@app/shared/models/list';

export class SMPLog extends BaseWithId {

    public client_id: string;
    public log_datetime: Date;
    public action_code: string;
    public action: string;
    public category: string;
    public category_code: string;
    public state: string;
    public user_name: string;
    public user_id: string;
    public visible: boolean;
    public message: string;

    constructor(json?: any) {
        super(json);
    }

    protected setObjectMappings(json: any): any {
        return Object.assign(super.setObjectMappings(json), {
            log_datetime: json && json.log_datetime ? new Date(json.log_datetime) : null
        });
    }
}

export class BillingLog extends BaseWithId {

    public client_id: string;
    public duplicate: boolean;
    public instant: Date;
    public source: string;
    public user_id: string;
    public user_name: string;
    public smp_case_no: string;
    public smp_case_id: string;
    public vehicle_manufacturer: string;
    public vehicle_model: string;
    public vehicle_submodel: string;
    public vin: string;

    constructor(json?: any) {
        super(json);
    }

    protected setObjectMappings(json: any): any {
        return Object.assign(super.setObjectMappings(json), {
            instant: json && json.instant ? new Date(json.instant) : null
        });
    }
}

export class CaseLogsContainer extends BaseModel {

    public case_no: string;
    public categories: string[];
    public logs: BaseWithIdList<SMPLog>;
    public users: string[];

    constructor(json?: any) {
        super(json);
    }

    protected setObjectMappings(json: any): any {
        return Object.assign(super.setObjectMappings(json), {
            categories: json && json.categories ? json.categories : [],
            logs: new BaseWithIdList(SMPLog, json && json.logs || []),
            users: json && json.users ? json.users : []
        });
    }
}
